import { trigger, animate, transition, style, animation, useAnimation } from '@angular/animations';

const fadeInAnimation = animation(
  [style({ opacity: 0 }), animate('{{ enterDuration }}ms ease-in', style({ opacity: 1 }))],
  { params: { enterDuration: 3000 } },
);

const fadeOutAnimation = animation([animate('{{ leaveDuration }}ms ease-out', style({ opacity: 0 }))], {
  params: { leaveDuration: 1000 },
});

export const simpleFadeAnimation = trigger('simpleFadeAnimation', [
  transition(':enter', useAnimation(fadeInAnimation)),
  transition(':leave', useAnimation(fadeOutAnimation)),
]);
